import { render, staticRenderFns } from "./SearchResultEmpty.vue?vue&type=template&id=b6e7c672&scoped=true&"
import script from "./SearchResultEmpty.vue?vue&type=script&lang=js&"
export * from "./SearchResultEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e7c672",
  null
  
)

export default component.exports